export { default as View } from './component';